import type { OptionKV } from "~styled/selector/Selector";

export enum EEstadoMulticotizacion {
  Abandonada = "Abandonada",
  ConSolicitud = "ConSolicitud",
}

const TODOS = "";
export const ABANDONADA = EEstadoMulticotizacion.Abandonada;
export const CON_SOLICITUD = EEstadoMulticotizacion.ConSolicitud;

const estadosMulticotizacionOptions: Record<
  EEstadoMulticotizacion | typeof TODOS,
  string
> = {
  [TODOS]: "Todos",
  [ABANDONADA]: "Abandonada",
  [CON_SOLICITUD]: "Con Solicitud",
};

const estadosMulticotizacionFilter: OptionKV<
  EEstadoMulticotizacion | typeof TODOS
>[] = [
  { label: estadosMulticotizacionOptions[TODOS], value: TODOS },
  { label: estadosMulticotizacionOptions[ABANDONADA], value: ABANDONADA },
  { label: estadosMulticotizacionOptions[CON_SOLICITUD], value: CON_SOLICITUD },
];

export { estadosMulticotizacionOptions, estadosMulticotizacionFilter };
